import { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ShopNotificationMethods from
  './NotificationMethods/ShopNotificationMethods';
import BarberNotificationMethods from
  './NotificationMethods/BarberNotificationMethods';
import Common from
  './NotificationMethods/Common';
import { activeShop, getActiveType } from '../auth/selectors';


class NotificationMethods extends Component {
  static propTypes = {
    customer: PropTypes.bool,
    barber: PropTypes.bool,
  }

  static defaultProps = {
    customer: false,
    barber: false,
  }

  constructor(props) {
    super(props);

    if (props.barber) {
      return new BarberNotificationMethods(props);
    }

    if (props.customer) {
      return new Common(props);
    }

    return new ShopNotificationMethods(props);
  }
}


export default connect(
  (state, props) => {
    const isViewedByShopUser = (
      !!activeShop(state) && getActiveType(state) === 'shop' && !state.auth.isUserImpersonated
    );
    return {
      commonHiddenFields: (!!props.shop && isViewedByShopUser) ? ['phone'] : [],
    };
  },
)(NotificationMethods);
